  (function () {
    'use strict';
    const configEl = document.querySelector('[data-js="swym-config"]');
    if (!configEl) return;
    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (err) {
      return;
    }
    const I18N = config.i18n || {};
    const API_ENDPOINT = config.apiEndpoint;
    const API_KEY = config.apiKey;
    const PID = config.pid;
    const STOREFRONT_API_TOKEN = config.storefrontApiToken;
    const PROXY_URL_BASE = 'https://accounts-proxy.peppermayo.com/api/swym';

    const drawer = document.getElementById('swym-wishlist-drawer');
    if (!drawer || drawer.dataset.initialised === 'true') return;
    drawer.dataset.initialised = 'true';

    const bodyEl = drawer.querySelector('[data-swym-drawer-body]');
    const titleEl = drawer.querySelector('[data-swym-drawer-title]');

    const errorBanner = drawer.querySelector('[data-js="swym-error-banner"]');
    const errorMessage = drawer.querySelector('[data-js="swym-error-message"]');
    const errorClose = drawer.querySelector('[data-js="swym-error-close"]');

    /**
     * Displays an error message in the drawer banner.
     * @param {string} msg - The error message to display
     * @returns {void}
     */
    const showError = (msg) => {
      if (errorMessage && errorBanner) {
        errorMessage.textContent = msg || I18N.errorGeneric;
        errorBanner.style.display = 'flex';
      }
    };

    /**
     * Clears the error message from the drawer banner.
     * @returns {void}
     */
    const clearError = () => {
      if (errorBanner && errorMessage) {
        errorBanner.style.display = 'none';
        errorMessage.textContent = '';
      }
    };

    if (errorClose) {
      errorClose.addEventListener('click', clearError);
    }


    let listsData = [];
    let isCacheValid = false;
    let isMultiListRendered = false;
    let availabilityCache = {};
    let currentAbortController = null;
    let addToListSuccessTimer = null;

    let isDrawerOpened = false;
    let hasCleanedUp = false;
    const activeAbortControllers = new Set();
    drawer.addEventListener('drawer:opened', () => { isDrawerOpened = true; });
    drawer.addEventListener('drawer:open', () => { 
      isDrawerOpened = false; 
      hasCleanedUp = false;
      const overlay = document.querySelector('[data-page-overlay]');
      if (overlay) overlay.dataset.wishlistOpen = "true";
    });
    
    const cleanupDrawer = () => {
      if (hasCleanedUp) return;
      hasCleanedUp = true;
      isDrawerOpened = false; 
      activeAbortControllers.forEach(ac => ac.abort());
      activeAbortControllers.clear();
      if (currentAbortController) {
        currentAbortController.abort();
        currentAbortController = null;
      }
      if (addToListSuccessTimer) {
        clearTimeout(addToListSuccessTimer);
        addToListSuccessTimer = null;
      }
      clearError();
      resetToMainView(true);
      pendingFlipHeight = null;
      const overlay = document.querySelector('[data-page-overlay]');
      if (overlay) delete overlay.dataset.wishlistOpen;
    };
    drawer.addEventListener('drawer:close', cleanupDrawer);
    drawer.addEventListener('drawer:closed', cleanupDrawer);

    // Add view state
    let addToListMode = false;
    let currentAddProduct = null;
    let selectedAddVariantId = null;
    let selectedAddListIds = [];
    let targetOpenListId = null;

    // Switch between view containers inside the drawer body
    const sheetEl = drawer.querySelector('[data-js="bottom-drawer-sheet"]');
    let viewTransitionCleanupId = null;
    let pendingFlipHeight = null;

    /**
     * Snapshots the sheet's current height before a render mutates the active
     * view. switchView otherwise measures its "from" height AFTER the content
     * has already changed, so re-rendering the view you're on (e.g. emptying
     * the open list) reads an already-collapsed height, skips the animation,
     * and the mobile bottom sheet snaps shut instead of easing. No-op on desktop
     * (side panel is full-height) — the value is consumed by the next switchView.
     * @returns {void}
     */
    const captureFlipHeight = () => {
      if (sheetEl && !window.matchMedia('(min-width: 768px)').matches) {
        pendingFlipHeight = sheetEl.getBoundingClientRect().height;
      }
    };

    /**
     * Switches the active view inside the drawer body, easing the sheet
     * height between views on mobile (desktop is a full-height side panel).
     * @param {string} viewName - The data-view value to show
     * @returns {void}
     */
    const switchView = (viewName) => {
      if (viewTransitionCleanupId) {
        clearTimeout(viewTransitionCleanupId);
        viewTransitionCleanupId = null;
      }

      const canAnimate =
        sheetEl &&
        !window.matchMedia('(min-width: 768px)').matches &&
        !window.themeUtils?.prefersReducedMotion;

      if (!canAnimate) {
        pendingFlipHeight = null;
        bodyEl.setAttribute('data-active-view', viewName);
        return;
      }

      const oldHeight = pendingFlipHeight != null ? pendingFlipHeight : sheetEl.getBoundingClientRect().height;
      pendingFlipHeight = null;
      bodyEl.setAttribute('data-active-view', viewName);
      const newHeight = sheetEl.getBoundingClientRect().height;

      if (newHeight === oldHeight) {
        sheetEl.style.height = '';
        sheetEl.style.overflow = '';
        sheetEl.style.transition = '';
        return;
      }

      sheetEl.style.height = oldHeight + 'px';
      sheetEl.style.overflow = 'hidden';
      sheetEl.getBoundingClientRect(); // force reflow

      const cleanup = () => {
        sheetEl.removeEventListener('transitionend', onTransitionEnd);
        sheetEl.style.height = '';
        sheetEl.style.overflow = '';
        sheetEl.style.transition = '';
        viewTransitionCleanupId = null;
      };

      const onTransitionEnd = (event) => {
        if (event.propertyName === 'height') cleanup();
      };

      sheetEl.addEventListener('transitionend', onTransitionEnd);
      viewTransitionCleanupId = setTimeout(cleanup, 500);

      requestAnimationFrame(() => {
        sheetEl.style.transition = 'height var(--motion-drawer) var(--ease-out-quint)';
        sheetEl.style.height = newHeight + 'px';
      });
    };

    // Listen for custom wishlist update events to invalidate cache and refetch if open
    if (window.themeUtils?.on) {
      window.themeUtils.on('wishlist-update', (e) => {
        isCacheValid = false;
        isMultiListRendered = false;
        
        // Only fetch if the event did NOT originate from this drawer
        if (e?.detail?.source !== 'swym-wishlist' && drawer.dataset.state === 'open') {
          fetchWishlists(true);
        }
      });
    }

    /**
     * Gets a cookie by name.
     * @param {string} name - The name of the cookie
     * @returns {string|null} The cookie value or null
     */
    const getCookie = (name) => {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      if (match) return match[2];
      return null;
    };

    /**
     * Sets a cookie with an optional expiration in days.
     * @param {string} name - The name of the cookie
     * @param {string} value - The value of the cookie
     * @param {number} [days=365] - Number of days until expiration
     * @returns {void}
     */
    const setCookie = (name, value, days = 365) => {
      const d = new Date();
      d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = `${name}=${value}; expires=${d.toUTCString()}; path=/`;
    };

    /**
     * Expires a cookie so a stale value can be regenerated on the next request.
     * @param {string} name - The name of the cookie
     * @returns {void}
     */
    const deleteCookie = (name) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    };

    let authPromise = null;

    /**
     * Authenticates the user with Swym and sets session cookies.
     * @returns {Promise<void>}
     */
    const authenticateUser = async () => {
      if (!API_ENDPOINT || !PID || !API_KEY) return;
      
      const email = drawer.dataset.customer;
      let uuid = getCookie('swym-uuid');
      
      if (!uuid) {
        uuid = crypto.randomUUID();
        setCookie('swym-uuid', uuid, 365);
      }

      const currentAuthId = email || uuid;
      const lastAuthId = getCookie('swym-last-auth');
      
      if (lastAuthId === currentAuthId && getCookie('swym-regid')) {
        return;
      }

      const bodyParams = new URLSearchParams();
      bodyParams.append('useragenttype', 'web');
      if (email) {
        bodyParams.append('useremail', email);
      } else {
        bodyParams.append('uuid', uuid);
      }

      try {
        const basicAuth = btoa(`${PID}:${API_KEY}`);
        const proxyUrl = new URL(PROXY_URL_BASE);
        proxyUrl.searchParams.append('endpoint', API_ENDPOINT);
        proxyUrl.searchParams.append('path', '/storeadmin/v3/user/generate-regid');
        proxyUrl.searchParams.append('pid', PID);
        
        const response = await fetch(proxyUrl.toString(), {
          method: 'POST',
          headers: {
            'Authorization': `Basic ${basicAuth}`,
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          },
          body: bodyParams.toString()
        });

        if (!response.ok) throw new Error('Swym auth failed');
        const data = await response.json();
        
        if (data.regid) {
          setCookie('swym-regid', data.regid, 365);
          setCookie('swym-last-auth', currentAuthId, 365);
        }
        if (data.sessionid) {
          setCookie('swym-session-id', data.sessionid, 365);
        }
      } catch (err) {
        console.error('Failed to generate Swym regid:', err);
      }
    };

    authPromise = authenticateUser();

    // Formatting currency (basic fallback)
    /**
     * Formats a price in cents to the active store currency.
     * @param {number} cents - The price in cents
     * @returns {string} Formatted price string
     */
    const formatMoney = (cents) => {
      const format = drawer.dataset.moneyFormat || '{{amount}}';
      if (typeof window.AthosAPI !== 'undefined' && window.AthosAPI.formatMoney) {
        return window.AthosAPI.formatMoney(cents, format, true);
      }

      // Fallback formatting if AthosAPI is not loaded yet
      const val = cents / 100;
      const placeholder = new RegExp('\\x7b\\x7b\\s*(\\w+)\\s*\\x7d\\x7d');
      const match = typeof format === 'string' ? format.match(placeholder) : null;
      const key = match ? match[1] : 'amount';

      const addSeparators = (numStr, thousands, decimal) => {
        const parts = numStr.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
      };

      let value;
      switch (key) {
        case 'amount_no_decimals':
          value = addSeparators(String(Math.round(val)), ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = addSeparators(val.toFixed(2), '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = addSeparators(String(Math.round(val)), '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = addSeparators(val.toFixed(2), "'", '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = addSeparators(String(Math.round(val)), ' ', '.');
          break;
        case 'amount_with_space_separator':
          value = addSeparators(val.toFixed(2), ' ', ',');
          break;
        case 'amount_with_period_and_space_separator':
          value = addSeparators(val.toFixed(2), ' ', '.');
          break;
        default:
          value = addSeparators(val.toFixed(2), ',', '.');
      }

      return match ? format.replace(match[0], value) : value;
    };

    /**
     * Resizes a Shopify CDN image URL to the specified width.
     * If the URL is not a Shopify CDN URL, returns it unchanged.
     * @param {string} url - Original image URL
     * @param {number} width - Target width in pixels
     * @returns {string} Resized image URL
     */
    const resizeImage = (url, width) => {
      if (!url) return '';
      if (!url.includes('cdn.shopify.com') && !url.includes('/cdn/')) return url;

      try {
        let cleanUrl = url;
        if (cleanUrl.startsWith('//')) {
          cleanUrl = 'https:' + cleanUrl;
        } else if (cleanUrl.startsWith('/')) {
          cleanUrl = window.location.origin + cleanUrl;
        }

        const urlObj = new URL(cleanUrl);
        if (urlObj.hostname.includes('shopify.com')) {
          urlObj.protocol = 'https:';
        }

        if (urlObj.searchParams.has('width')) {
          urlObj.searchParams.set('width', width);
          return urlObj.toString();
        }
        
        // Handle URLs with size suffixes in filename, e.g. _620x620 or _620x
        const path = urlObj.pathname;
        const sizePattern = /_(?:[0-9]+x[0-9]*|[0-9]*x[0-9]+)\.(jpg|jpeg|png|gif|webp)/i;
        if (sizePattern.test(path)) {
          urlObj.pathname = path.replace(sizePattern, `_${width}x.$1`);
          return urlObj.toString();
        }

        urlObj.searchParams.set('width', width);
        return urlObj.toString();
      } catch (err) {
        return url;
      }
    };

    /**
     * Renders the login nudge view when user is unauthenticated.
     * @returns {void}
     */
    const renderNudge = () => {
      captureFlipHeight();
      const container = bodyEl.querySelector('[data-view="nudge"]');
      if (container && container.children.length === 0) {
        const tmpl = document.querySelector('[data-js="tmpl-swym-nudge"]');
        if (tmpl) container.appendChild(tmpl.content.cloneNode(true));
      }
      switchView('nudge');
    };

    /**
     * Renders the empty wishlist view.
     * @returns {void}
     */
    const renderEmpty = () => {
      captureFlipHeight();
      const container = bodyEl.querySelector('[data-view="empty"]');
      if (container && container.children.length === 0) {
        const tmpl = document.querySelector('[data-js="tmpl-swym-empty"]');
        if (tmpl) container.appendChild(tmpl.content.cloneNode(true));
      }
      switchView('empty');
    };

    /**
     * Renders the multi-list view showing all user wishlists.
     * @param {boolean} [forceRebuild=false] - Whether to force a DOM rebuild
     * @returns {void}
     */
    const renderMultiList = (forceRebuild = false) => {
      captureFlipHeight();
      clearError();
      titleEl.textContent = I18N.wishlist;
      const container = bodyEl.querySelector('[data-view="multi"]');
        
        if (!isMultiListRendered || forceRebuild) {
          while(container.firstChild) container.removeChild(container.firstChild);
          const listCardTmpl = document.querySelector('[data-js="tmpl-swym-list-card"]');
          
          listsData.forEach((list) => {
            if (!listCardTmpl) return;
            const node = listCardTmpl.content.cloneNode(true);
            const card = node.querySelector('.swym-list-card');
            card.dataset.listId = list.lid;
            node.querySelector('.swym-list-card__title').textContent = list.lname || I18N.wishlist;
            
            const previewsContainer = node.querySelector('.swym-list-card__previews');
            if (list.listcontents && list.listcontents.length > 0) {
              const previews = list.listcontents.slice(0, 6);
              previews.forEach((item) => {
                const wrapper = document.createElement('div');
                wrapper.className = 'image swym-list-card__preview-image';
                wrapper.dataset.skeleton = '';
                const img = document.createElement('img');
                img.loading = 'lazy';
                img.src = resizeImage(item.iu, 160);
                img.alt = item.dt;
                wrapper.appendChild(img);
                previewsContainer.appendChild(wrapper);
              });

              if (list.listcontents.length > 6) {
                const remaining = list.listcontents.length - 6;
                const remainingEl = document.createElement('div');
                remainingEl.className = 'swym-list-card__remaining';
                remainingEl.textContent = `+${remaining}`;
                previewsContainer.appendChild(remainingEl);
              }
            } else {
              const emptyEl = document.createElement('div');
              emptyEl.className = 'swym-list-card__empty-msg';
              emptyEl.textContent = I18N.emptySingle;
              previewsContainer.appendChild(emptyEl);
            }
            container.appendChild(node);
          });

          const cards = container.querySelectorAll('.swym-list-card');
          cards.forEach((card) => {
            card.addEventListener('click', () => {
              const listId = card.dataset.listId;
              const list = listsData.find((l) => l.lid === listId);
              if (list) {
                fetchAvailabilityAndRenderList(list, true);
              }
            });
          });
          isMultiListRendered = true;
        }

        switchView('multi');
        window.themeSkeleton?.sweep(drawer);
    };

    /**
     * Fetches availability for wishlist items and renders the single list view.
     * @param {Object} list - The list data object
     * @param {boolean} [showBack=false] - Whether to show the back button
     * @returns {void}
     */
    const fetchAvailabilityAndRenderList = (list, showBack = false) => {
      clearError();
      if (!list.listcontents || list.listcontents.length === 0 || !STOREFRONT_API_TOKEN) {
        drawer.classList.remove('is-loading');
        renderSingleList(list, null, showBack);
        return;
      }

      // Check cache first
      const missingVariantIds = [];
      const cachedDataMap = {};
      list.listcontents.forEach((item) => {
        if (availabilityCache[item.epi]) {
          cachedDataMap[item.epi] = availabilityCache[item.epi];
        } else {
          missingVariantIds.push(`gid://shopify/ProductVariant/${item.epi}`);
        }
      });

      if (missingVariantIds.length === 0) {
        drawer.classList.remove('is-loading');
        renderSingleList(list, cachedDataMap, showBack);
        return;
      }

      drawer.classList.add('is-loading');
      // Without a country context the Storefront API returns base-currency
      // (AUD) prices; market shoppers need presentment prices to match the PDP.
      const country = window.Shopify?.country;
      const inContext = typeof country === 'string' && /^[A-Z]{2}$/.test(country)
        ? `@inContext(country: ${country}) `
        : '';
      const query = `
        query ${inContext}{
          nodes(ids: ${JSON.stringify(missingVariantIds)}) {
            ... on ProductVariant {
              id
              availableForSale
              price {
                amount
              }
              compareAtPrice {
                amount
              }
              image {
                url(transform: { maxWidth: 160 })
              }
              product {
                tags
              }
            }
          }
        }
      `;

      const ac = new AbortController();
      activeAbortControllers.add(ac);

      fetch((window.Shopify?.routes?.root || '/') + 'api/2026-04/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_API_TOKEN
        },
        body: JSON.stringify({ query }),
        signal: ac.signal
      })
      .then(res => {
        if (!res.ok) throw new Error('Storefront API error');
        return res.json();
      })
      .then(resData => {
        drawer.classList.remove('is-loading');
        if (resData.data && resData.data.nodes) {
          resData.data.nodes.forEach(node => {
            if (node && node.id) {
              const idStr = node.id.split('/').pop();
              availabilityCache[idStr] = node;
              cachedDataMap[idStr] = node;
            }
          });
        }
        renderSingleList(list, cachedDataMap, showBack);
      })
      .catch(err => {
        if (err.name === 'AbortError') {
          drawer.classList.remove('is-loading');
          return;
        }
        console.error('Storefront GraphQL error:', err);
        drawer.classList.remove('is-loading');
        renderSingleList(list, cachedDataMap, showBack);
      })
      .finally(() => {
        activeAbortControllers.delete(ac);
      });
    };

    /**
     * Renders a single wishlist and its contents.
     * @param {Object} list - The list data object
     * @param {Object|null} [variantDataMap=null] - Mapping of variant IDs to availability data
     * @param {boolean} [showBack=false] - Whether to show the back button
     * @returns {void}
     */
    const renderSingleList = (list, variantDataMap = null, showBack = false) => {
      captureFlipHeight();
      titleEl.textContent = list.lname || I18N.wishlist;
      const container = bodyEl.querySelector('[data-view="single"]');

        const isAlreadyRendered = container.dataset.renderedListId === list.lid && 
                                  container.dataset.itemCount === String(list.listcontents ? list.listcontents.length : 0);

        if (!isAlreadyRendered) {
          while(container.firstChild) container.removeChild(container.firstChild);
          container.dataset.renderedListId = list.lid;
          container.dataset.itemCount = list.listcontents ? list.listcontents.length : 0;

          if (showBack) {
            const backTmpl = document.querySelector('[data-js="tmpl-swym-single-list-back"]');
            if (backTmpl) container.appendChild(backTmpl.content.cloneNode(true));
          }

          if (!list.listcontents || list.listcontents.length === 0) {
            const emptySingleTmpl = document.querySelector('[data-js="tmpl-swym-empty-single"]');
            if (emptySingleTmpl) container.appendChild(emptySingleTmpl.content.cloneNode(true));
          } else {
            const itemCardTmpl = document.querySelector('[data-js="tmpl-swym-item-card"]');
            list.listcontents.forEach((item) => {
            if (!itemCardTmpl) return;
            const node = itemCardTmpl.content.cloneNode(true);
            
            const card = node.querySelector('.swym-item-card');
            card.dataset.variantId = item.epi;
            card.dataset.productId = item.empi;
            
            const img = node.querySelector('.swym-item-card__image img');
            let imageUrl = resizeImage(item.iu, 160);
            img.alt = item.dt;
            
            node.querySelector('.swym-item-card__title').textContent = item.dt;
            node.querySelector('.swym-item-card__variant').textContent = item.vi || '';
            
            const priceContainer = node.querySelector('.swym-item-card__price');
            let priceCents = item.pr * 100;
            let compareAtPriceCents = null;

            let variantData = null;
            if (variantDataMap !== null) {
              variantData = variantDataMap[item.epi];
              if (variantData) {
                if (variantData.price && variantData.price.amount) {
                  priceCents = parseFloat(variantData.price.amount) * 100;
                }
                if (variantData.compareAtPrice && variantData.compareAtPrice.amount) {
                  compareAtPriceCents = parseFloat(variantData.compareAtPrice.amount) * 100;
                }
                if (!imageUrl && variantData.image && variantData.image.url) {
                  imageUrl = variantData.image.url;
                }
              }
            }
            img.src = imageUrl;

            const promo =
              window.PromoPricing && typeof window.PromoPricing.resolve === 'function' && variantData
                ? window.PromoPricing.resolve({
                    priceCents: Math.round(priceCents),
                    tags: variantData.product && variantData.product.tags,
                  })
                : null;

            if (compareAtPriceCents && compareAtPriceCents > priceCents) {
              const saleTmpl = document.querySelector('[data-js="tmpl-swym-price-sale"]');
              if (saleTmpl) {
                const clone = saleTmpl.content.cloneNode(true);
                clone.querySelector('[data-type="sale"]').textContent = formatMoney(compareAtPriceCents);
                clone.querySelector('[data-type="discount"]').textContent = formatMoney(priceCents);
                priceContainer.textContent = '';
                priceContainer.appendChild(clone);
              }
            } else {
              priceContainer.textContent = formatMoney(priceCents);
            }
            if (promo) {
              const promoText = window.PromoPricing.message(formatMoney(promo.priceCents), promo.percent);
              if (promoText) {
                if (priceContainer.childElementCount === 0) {
                  const plainSpan = document.createElement('span');
                  plainSpan.textContent = priceContainer.textContent;
                  priceContainer.textContent = '';
                  priceContainer.appendChild(plainSpan);
                }
                const promoSpan = document.createElement('span');
                promoSpan.dataset.type = 'promo';
                promoSpan.textContent = promoText;
                priceContainer.appendChild(promoSpan);
              }
            }
            
            const addBtn = node.querySelector('[data-js="add-to-bag"]');
            addBtn.dataset.variantId = item.epi;

            if (variantDataMap !== null) {
              const variantData = variantDataMap[item.epi];
              const isAvailable = variantData ? variantData.availableForSale : undefined;
              if (isAvailable === false) {
                addBtn.disabled = true;
                addBtn.textContent = I18N.soldOut;
              } else if (isAvailable === undefined) {
                addBtn.disabled = true;
                addBtn.textContent = I18N.unavailable;
              }
            }
            
            const removeBtn = node.querySelector('[data-js="remove-item"]');
            removeBtn.dataset.epi = item.epi;
            removeBtn.dataset.empi = item.empi;
            removeBtn.dataset.lid = list.lid;
            
            container.appendChild(node);
          });
        }

        // Bind Back button
        if (showBack) {
          container.querySelector('[data-action="back"]').addEventListener('click', () => {
            renderMultiList();
          });
        }

        // Bind Add to bag
        const addBtns = container.querySelectorAll('[data-js="add-to-bag"]');
        addBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            const variantId = e.target.dataset.variantId;

            clearError();
            drawer.classList.add('is-loading');

            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] }),
            })
              .then((res) => {
                if (!res.ok) {
                  return res.json().then((errData) => {
                    throw new Error(errData.description || 'Could not add to bag');
                  });
                }
                return res.json();
              })
              .then((data) => {
                document.dispatchEvent(
                  new CustomEvent('cart:added', {
                    detail: {
                      openMinicart: true,
                    },
                  })
                );
                drawer.classList.remove('is-loading');
              })
              .catch((err) => {
                if (err.name === 'AbortError') return;
                showError(drawer.dataset.labelErrorCart);
                drawer.classList.remove('is-loading');
              });
          });
        });

        // Bind Remove
        const removeBtns = container.querySelectorAll('[data-js="remove-item"]');
        removeBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            const target = e.currentTarget;
            const epi = target.dataset.epi;
            const empi = target.dataset.empi;
            const lid = target.dataset.lid;
            removeItem(epi, empi, lid, list);
          });
        });

        // Append Delete Wishlist button
        const deleteTmpl = document.querySelector('[data-js="tmpl-swym-delete-list"]');
        if (deleteTmpl) {
          const deleteNode = deleteTmpl.content.cloneNode(true);
          const deleteBtn = deleteNode.querySelector('[data-action="delete-list"]');
          deleteBtn.dataset.lid = list.lid;
          container.appendChild(deleteNode);

          // Bind Delete Wishlist button
          deleteBtn.addEventListener('click', (e) => {
            const lid = e.currentTarget.dataset.lid;
            deleteList(lid);
          });
        }
        }

        switchView('single');
        window.themeSkeleton?.sweep(drawer);
    };

    /**
     * Fetches all wishlists for the authenticated user.
     * @param {boolean} [forceRefetch=false] - Whether to bypass local cache
     * @returns {void}
     */
    const fetchWishlists = (forceRefetch = false) => {
      if (!API_ENDPOINT || !PID) {
        renderNudge();
        return;
      }

      if (isCacheValid && !forceRefetch) {
        drawer.classList.remove('is-loading');
        if (addToListMode && currentAddProduct) {
          renderAddToList(currentAddProduct);
        } else if (targetOpenListId) {
          const targetList = listsData.find(l => l.lid === targetOpenListId);
          if (targetList) {
            fetchAvailabilityAndRenderList(targetList, true);
          } else {
            renderMultiList();
          }
          targetOpenListId = null;
        } else if (listsData.length === 0) {
          renderEmpty();
        } else if (listsData.length === 1) {
          fetchAvailabilityAndRenderList(listsData[0], false);
        } else {
          renderMultiList();
        }
        return;
      }

      if (!isCacheValid) {
        // Hide views while loading fresh data
        switchView('');
        titleEl.textContent = addToListMode ? I18N.addTitle : I18N.wishlist;
      }

      drawer.classList.add('is-loading');

      if (!getCookie('swym-regid')) {
        drawer.classList.remove('is-loading');
        renderNudge();
        return;
      }

      if (currentAbortController) {
        currentAbortController.abort();
      }
      currentAbortController = new AbortController();
      const signal = currentAbortController.signal;

      /**
       * Fetches the shopper's wishlists for the current regid. A regid can be
       * invalidated upstream (e.g. the Swym store is reconfigured) while still
       * cached client-side for a year; recover once by clearing it,
       * re-authenticating, and retrying so the shopper is not stuck.
       * @param {boolean} allowRetry - Whether a bad regid may trigger one re-auth + retry.
       * @returns {Promise<Array|null>} The parsed lists payload.
       */
      const requestLists = (allowRetry) => {
        const proxyUrl = new URL(PROXY_URL_BASE);
        proxyUrl.searchParams.append('endpoint', API_ENDPOINT);
        proxyUrl.searchParams.append('path', '/api/v3/lists/fetch-lists');
        proxyUrl.searchParams.append('pid', PID);

        const bodyParams = new URLSearchParams();
        bodyParams.append('regid', getCookie('swym-regid'));
        const sessionid = getCookie('swym-session-id');
        if (sessionid) {
          bodyParams.append('sessionid', sessionid);
        }

        return fetch(proxyUrl.toString(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          },
          body: bodyParams.toString(),
          signal
        }).then(async (res) => {
          if (res.ok) return res.json();
          if (allowRetry && res.status === 400 && (await res.text()).includes('sw-badregid')) {
            deleteCookie('swym-regid');
            deleteCookie('swym-last-auth');
            await authenticateUser();
            if (!getCookie('swym-regid')) throw new Error('Failed to fetch wishlists');
            return requestLists(false);
          }
          throw new Error('Failed to fetch wishlists');
        });
      };

      requestLists(true)
        .then((data) => {
          drawer.classList.remove('is-loading');
          if (data && Array.isArray(data)) {
            listsData = data;
            isCacheValid = true;
            isMultiListRendered = false; // Force rebuild multi-list with fresh data
            const singleContainer = bodyEl.querySelector('[data-view="single"]');
            if (singleContainer) {
              delete singleContainer.dataset.renderedListId;
              delete singleContainer.dataset.itemCount;
            }
            if (addToListMode && currentAddProduct) {
              renderAddToList(currentAddProduct);
            } else if (targetOpenListId) {
              const targetList = listsData.find(l => l.lid === targetOpenListId);
              if (targetList) {
                fetchAvailabilityAndRenderList(targetList, true);
              } else {
                renderMultiList();
              }
              targetOpenListId = null;
            } else if (listsData.length === 0) {
              renderEmpty();
            } else if (listsData.length === 1) {
              fetchAvailabilityAndRenderList(listsData[0], false);
            } else {
              renderMultiList();
            }
          } else {
            renderEmpty();
          }
        })
        .catch((err) => {
          if (err.name === 'AbortError') return;
          console.error('Swym fetch error');
          drawer.classList.remove('is-loading');
          showError(drawer.dataset.labelErrorFetch);
        });
    };

    /**
     * Removes an item from a specific wishlist.
     * @param {string|number} epi - Variant ID
     * @param {string|number} empi - Product ID
     * @param {string} lid - List ID
     * @param {Object} listData - The list data object
     * @returns {void}
     */
    const removeItem = (epi, empi, lid, listData) => {
      if (!API_ENDPOINT || !PID) return;

      drawer.classList.add('is-loading');

      const regid = getCookie('swym-regid');
      const sessionid = getCookie('swym-session-id');

      const proxyUrl = new URL(PROXY_URL_BASE);
      proxyUrl.searchParams.append('endpoint', API_ENDPOINT);
      proxyUrl.searchParams.append('path', '/api/v3/lists/update-ctx');
      proxyUrl.searchParams.append('pid', PID);

      const itemToDelete = listData.listcontents.find((item) => String(item.epi) === String(epi));
      const payloadItem = {
        epi: itemToDelete ? itemToDelete.epi : (Number(epi) || epi),
        empi: itemToDelete ? itemToDelete.empi : (Number(empi) || empi),
        du: itemToDelete && itemToDelete.du ? itemToDelete.du : window.location.href
      };

      const bodyParams = new URLSearchParams();
      if (regid) bodyParams.append('regid', regid);
      if (sessionid) bodyParams.append('sessionid', sessionid);
      bodyParams.append('lid', lid);
      bodyParams.append('d', JSON.stringify([payloadItem]));

      const ac = new AbortController();
      activeAbortControllers.add(ac);

      fetch(proxyUrl.toString(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json'
        },
        body: bodyParams.toString(),
        signal: ac.signal
      })
        .then((res) => {
          if (!res.ok) throw new Error('Failed to remove item');
          return res.json();
        })
        .then((data) => {
          // Remove from local data
          listData.listcontents = listData.listcontents.filter((item) => String(item.epi) !== String(epi));
          isMultiListRendered = false; // Force rebuild multi-list with updated content

          // Emit custom event to notify other components (e.g. header badge, PDP buttons)
          window.themeUtils?.emit('wishlist-update', { source: 'swym-wishlist' });

          if (listData.listcontents.length === 0) {
            fetchWishlists(true); // Refetch and re-evaluate view
          } else {
            fetchAvailabilityAndRenderList(listData, listsData.length > 1);
          }
        })
        .catch((err) => {
          if (err.name === 'AbortError') {
            drawer.classList.remove('is-loading');
            return;
          }
          console.error('Failed to remove item');
          drawer.classList.remove('is-loading');
          showError(drawer.dataset.labelErrorRemove);
        })
        .finally(() => {
          activeAbortControllers.delete(ac);
        });
    };

    /**
     * Deletes a wishlist entirely.
     * @param {string} lid - List ID
     * @returns {void}
     */
    const deleteList = (lid) => {
      if (!API_ENDPOINT || !PID) return;

      drawer.classList.add('is-loading');

      const regid = getCookie('swym-regid');
      const sessionid = getCookie('swym-session-id');

      const proxyUrl = new URL(PROXY_URL_BASE);
      proxyUrl.searchParams.append('endpoint', API_ENDPOINT);
      proxyUrl.searchParams.append('path', '/api/v3/lists/delete-list');
      proxyUrl.searchParams.append('pid', PID);

      const bodyParams = new URLSearchParams();
      if (regid) bodyParams.append('regid', regid);
      if (sessionid) bodyParams.append('sessionid', sessionid);
      bodyParams.append('lid', lid);

      const ac = new AbortController();
      activeAbortControllers.add(ac);

      fetch(proxyUrl.toString(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json'
        },
        body: bodyParams.toString(),
        signal: ac.signal
      })
        .then((res) => {
          if (!res.ok) throw new Error('Failed to delete list');
          return res.json();
        })
        .then((data) => {
          drawer.classList.remove('is-loading');
          // Remove from local data
          listsData = listsData.filter((list) => list.lid !== lid);
          isMultiListRendered = false; // Force rebuild multi-list
          isCacheValid = true; // Local cache is updated manually now

          window.themeUtils?.emit('wishlist-update', { source: 'swym-wishlist' });

          const singleContainer = bodyEl.querySelector('[data-view="single"]');
          if (singleContainer) {
            delete singleContainer.dataset.renderedListId;
            delete singleContainer.dataset.itemCount;
          }

          if (listsData.length === 0) {
            renderEmpty();
          } else {
            renderMultiList();
          }
        })
        .catch((err) => {
          if (err.name === 'AbortError') {
            drawer.classList.remove('is-loading');
            return;
          }
          console.error('Failed to delete list');
          drawer.classList.remove('is-loading');
          showError(drawer.dataset.labelErrorDelete);
        })
        .finally(() => {
          activeAbortControllers.delete(ac);
        });
    };

    /**
     * Resets the drawer state back to the main list view.
     * @param {boolean} [skipFetch=false] - Whether to skip triggering network fetches
     * @returns {void}
     */
    const resetToMainView = (skipFetch = false) => {
      clearError();
      addToListMode = false;
      currentAddProduct = null;
      selectedAddVariantId = null;
      selectedAddListIds = [];
      targetOpenListId = null;

      if (skipFetch) return;

      if (listsData.length === 0) {
        renderEmpty();
      } else if (listsData.length === 1) {
        fetchAvailabilityAndRenderList(listsData[0], false);
      } else {
        renderMultiList();
      }
    };

    /**
     * Renders the Add to List view for a specific product.
     * @param {Object} productInfo - The product data payload
     * @returns {void}
     */
    const renderAddToList = (productInfo) => {
      captureFlipHeight();
      titleEl.textContent = I18N.addTitle;
      const container = bodyEl.querySelector('[data-view="add"]');
        while(container.firstChild) container.removeChild(container.firstChild);

        const tmpl = document.querySelector('[data-js="tmpl-swym-add-to-list"]');
        if (!tmpl) return;

        const node = tmpl.content.cloneNode(true);

        // Populate Product Info
        const img = node.querySelector('.swym-add-view__image img');
        if (productInfo.image) {
          img.src = resizeImage(productInfo.image, 160);
        } else {
          img.style.display = 'none';
        }
        
        node.querySelector('.swym-add-view__title').textContent = productInfo.title;

        const promoText =
          productInfo.promoText ||
          productInfo.promo_message ||
          (productInfo.promoPercent && window.PromoPricing && typeof window.PromoPricing.message === 'function'
            ? window.PromoPricing.message(formatMoney(productInfo.promoPrice), productInfo.promoPercent)
            : '');

        const priceContainer = node.querySelector('.swym-add-view__price');
        if (productInfo.compareAtPrice && productInfo.compareAtPrice > productInfo.price) {
          const saleTmpl = document.querySelector('[data-js="tmpl-swym-price-sale"]');
          if (saleTmpl) {
            const clone = saleTmpl.content.cloneNode(true);
            clone.querySelector('[data-type="sale"]').textContent = formatMoney(productInfo.compareAtPrice);
            clone.querySelector('[data-type="discount"]').textContent = formatMoney(productInfo.price);
            priceContainer.textContent = '';
            priceContainer.appendChild(clone);
          }
        } else {
          priceContainer.textContent = formatMoney(productInfo.price);
        }
        if (promoText) {
          if (priceContainer.childElementCount === 0) {
            const plainSpan = document.createElement('span');
            plainSpan.textContent = priceContainer.textContent;
            priceContainer.textContent = '';
            priceContainer.appendChild(plainSpan);
          }
          const promoSpan = document.createElement('span');
          promoSpan.dataset.type = 'promo';
          promoSpan.textContent = promoText;
          priceContainer.appendChild(promoSpan);
        }

        // Render Sizes
        const sizesContainer = node.querySelector('.swym-add-view__sizes');
        if (productInfo.variants && productInfo.variants.length > 0) {
          productInfo.variants.forEach(variant => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'swym-add-view__size';
            btn.dataset.variantId = variant.id;
            btn.dataset.available = variant.available;
            btn.textContent = variant.size || variant.label;
            
            // Auto-select if it's the only variant
            if (productInfo.variants.length === 1 || selectedAddVariantId === String(variant.id)) {
              btn.dataset.selected = 'true';
              selectedAddVariantId = String(variant.id);
            }

            btn.addEventListener('click', () => {
              sizesContainer.querySelectorAll('.swym-add-view__size').forEach(b => b.dataset.selected = 'false');
              btn.dataset.selected = 'true';
              selectedAddVariantId = String(variant.id);
              updateAddCtaState();
            });
            sizesContainer.appendChild(btn);
          });
        }

        // Render Lists
        const listsContainer = node.querySelector('.swym-add-view__lists');
        if (listsData.length === 0) {
          const emptyMsg = document.createElement('div');
          emptyMsg.className = 'swym-list-card__empty-msg';
          emptyMsg.textContent = I18N.noLists;
          listsContainer.appendChild(emptyMsg);
        } else {
          listsData.forEach(list => {
            const listBtn = document.createElement('button');
            listBtn.type = 'button';
            listBtn.className = 'swym-add-view__list-option';
            listBtn.dataset.listId = list.lid;
            
            const listName = document.createElement('span');
            listName.className = 'swym-add-view__list-name';
            listName.textContent = list.lname || I18N.wishlist;
            listBtn.appendChild(listName);

            const checkIcon = document.createElement('span');
            checkIcon.className = 'swym-add-view__list-check';
            const checkTmpl = document.querySelector('[data-js="tmpl-swym-icon-check"]');
            if (checkTmpl) checkIcon.appendChild(checkTmpl.content.cloneNode(true));
            listBtn.appendChild(checkIcon);

            // Auto-select if there's only one list or it's the selected one
            if (listsData.length === 1 || selectedAddListIds.includes(list.lid)) {
              listBtn.dataset.selected = 'true';
              if (!selectedAddListIds.includes(list.lid)) {
                selectedAddListIds.push(list.lid);
              }
            }

            listBtn.addEventListener('click', () => {
              if (listBtn.dataset.selected === 'true') {
                delete listBtn.dataset.selected;
                selectedAddListIds = selectedAddListIds.filter(id => id !== list.lid);
              } else {
                listBtn.dataset.selected = 'true';
                selectedAddListIds.push(list.lid);
              }
              updateAddCtaState();
            });
            listsContainer.appendChild(listBtn);
          });
        }

        // Create form interaction
        const createToggle = node.querySelector('[data-js="create-toggle"]');
        const createForm = node.querySelector('.swym-add-view__create-form');
        const createInput = node.querySelector('.swym-add-view__create-input');
        const createSubmit = node.querySelector('[data-js="create-submit"]');

        createToggle.addEventListener('click', () => {
          createToggle.style.display = 'none';
          createForm.style.display = 'flex';
          createInput.focus();
        });

        const handleCreate = () => {
          const lname = createInput.value.trim();
          if (!lname) return;
          createWishlist(lname, createSubmit, createForm, createToggle);
        };

        createSubmit.addEventListener('click', handleCreate);

        createInput.addEventListener('input', () => {
          createSubmit.disabled = createInput.value.trim() === '';
        });

        createInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            if (!createSubmit.disabled) {
              handleCreate();
            }
          }
        });

        // CTA
        const ctaBtn = node.querySelector('[data-js="add-submit"]');
        ctaBtn.addEventListener('click', () => {
          addToList(ctaBtn);
        });

        container.appendChild(node);
        updateAddCtaState();
        switchView('add');
        window.themeSkeleton?.sweep(drawer);
    };

    /**
     * Updates the state (disabled/enabled) of the Add CTA button.
     * @returns {void}
     */
    const updateAddCtaState = () => {
      const ctaBtn = bodyEl.querySelector('.swym-add-view__cta[data-js="add-submit"]');
      if (!ctaBtn) return;
      if (selectedAddVariantId && selectedAddListIds.length > 0) {
        ctaBtn.disabled = false;
      } else {
        ctaBtn.disabled = true;
      }
    };

    /**
     * Creates a new wishlist.
     * @param {string} lname - The name of the new list
     * @param {HTMLElement} submitBtn - The submit button
     * @param {HTMLElement} formEl - The form container
     * @param {HTMLElement} toggleEl - The toggle button
     * @returns {void}
     */
    const createWishlist = (lname, submitBtn, formEl, toggleEl) => {
      if (!API_ENDPOINT || !PID) return;
      submitBtn.disabled = true;
      submitBtn.dataset.state = 'loading';

      const regid = getCookie('swym-regid');
      const sessionid = getCookie('swym-session-id');

      const proxyUrl = new URL(PROXY_URL_BASE);
      proxyUrl.searchParams.append('endpoint', API_ENDPOINT);
      proxyUrl.searchParams.append('path', '/api/v3/lists/create');
      proxyUrl.searchParams.append('pid', PID);

      const bodyParams = new URLSearchParams();
      if (regid) bodyParams.append('regid', regid);
      if (sessionid) bodyParams.append('sessionid', sessionid);
      bodyParams.append('lname', lname);

      const ac = new AbortController();
      activeAbortControllers.add(ac);

      fetch(proxyUrl.toString(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json'
        },
        body: bodyParams.toString(),
        signal: ac.signal
      })
        .then((res) => {
          if (!res.ok) throw new Error('Failed to create wishlist');
          return res.json();
        })
        .then((data) => {
          submitBtn.disabled = false;
          delete submitBtn.dataset.state;
          if (data && data.lid) {
            listsData.push(data);
            isMultiListRendered = false; // Force rebuild multi-list cache
            selectedAddListIds.push(data.lid);
            
            // Re-render the add view to show the new list selected
            if (currentAddProduct) {
               renderAddToList(currentAddProduct);
            }
          }
        })
        .catch((err) => {
          if (err.name === 'AbortError') {
            submitBtn.disabled = false;
            delete submitBtn.dataset.state;
            return;
          }
          console.error('Failed to create wishlist');
          submitBtn.disabled = false;
          delete submitBtn.dataset.state;
        })
        .finally(() => {
          activeAbortControllers.delete(ac);
        });
    };

    /**
     * Submits the add-to-list request for the selected product, variant, and lists.
     * @param {HTMLElement} ctaBtn - The CTA button
     * @returns {Promise<void>}
     */
    const addToList = async (ctaBtn) => {
      if (!API_ENDPOINT || !PID || !selectedAddVariantId || selectedAddListIds.length === 0 || !currentAddProduct) return;
      
      ctaBtn.disabled = true;
      ctaBtn.dataset.state = 'loading';
      const ctaText = ctaBtn.querySelector('[data-js="cta-text"]');
      const ctaIcon = ctaBtn.querySelector('[data-js="cta-icon"]');
      
      ctaText.textContent = I18N.adding;

      const regid = getCookie('swym-regid');
      const sessionid = getCookie('swym-session-id');

      const proxyUrl = new URL(PROXY_URL_BASE);
      proxyUrl.searchParams.append('endpoint', API_ENDPOINT);
      proxyUrl.searchParams.append('path', '/api/v3/lists/update-ctx');
      proxyUrl.searchParams.append('pid', PID);

      const payloadItem = {
        epi: Number(selectedAddVariantId),
        empi: Number(currentAddProduct.id),
        du: currentAddProduct.url
      };
      // Self-describe price/title/image so the list view doesn't depend
      // solely on Swym server-side enrichment or the GraphQL rescue.
      if (Number.isFinite(currentAddProduct.price)) payloadItem.pr = currentAddProduct.price / 100;
      if (currentAddProduct.title) payloadItem.dt = currentAddProduct.title;
      if (currentAddProduct.image) payloadItem.iu = currentAddProduct.image;

      try {
        const promises = selectedAddListIds.map(lid => {
          const bodyParams = new URLSearchParams();
          if (regid) bodyParams.append('regid', regid);
          if (sessionid) bodyParams.append('sessionid', sessionid);
          bodyParams.append('lid', lid);
          bodyParams.append('a', JSON.stringify([payloadItem]));

          const ac = new AbortController();
          activeAbortControllers.add(ac);

          return fetch(proxyUrl.toString(), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            },
            body: bodyParams.toString(),
            signal: ac.signal
          }).then(res => {
            if (!res.ok) throw new Error('Failed to add to list');
            return res.json();
          });
        });

        await Promise.all(promises);

        ctaBtn.dataset.state = 'success';
        ctaText.textContent = I18N.added;
        ctaIcon.style.display = 'block';
        
        isCacheValid = false; // Need to fetch new wishlist contents
        isMultiListRendered = false;
        window.themeUtils?.emit('wishlist-update', { source: 'swym-wishlist' });

        addToListSuccessTimer = setTimeout(() => {
          targetOpenListId = selectedAddListIds.length === 1 ? selectedAddListIds[0] : null;
          addToListMode = false;
          currentAddProduct = null;
          selectedAddVariantId = null;
          selectedAddListIds = [];
          fetchWishlists(true); // Force refetch and render targetOpenListId
        }, 1500);
      } catch (err) {
        if (err.name === 'AbortError') {
          ctaBtn.disabled = false;
          delete ctaBtn.dataset.state;
          return;
        }
        console.error('Failed to add to wishlist');
        ctaBtn.disabled = false;
        delete ctaBtn.dataset.state;
        ctaText.textContent = I18N.addButton;
        showError(drawer.dataset.labelErrorAdd);
      }
    };

    /**
     * Preps the drawer state and opens it via the BottomDrawer primitive.
     * @returns {Promise<void>}
     */
    const openDrawer = async () => {
      if (addToListMode) {
        switchView('');
        titleEl.textContent = I18N.addTitle;
      }

      drawer.classList.add('is-loading');

      window.BottomDrawer?.open('swym-wishlist-drawer');

      if (authPromise) {
        await authPromise;
      }
      fetchWishlists();
    };

    document.addEventListener('click', (e) => {
      const addTrigger = e.target.closest('[data-js="wishlist-add"]');
      if (addTrigger) {
        e.preventDefault();
        e.stopPropagation();
        
        const card = addTrigger.closest('[data-js="product-card"]');
        if (!card) return;

        const productId = card.dataset.productId || card.getAttribute('data-product-id');
        const productHandle = card.dataset.productHandle || card.getAttribute('data-product-handle');
        if (!productId || !productHandle) return;

        let title = '';
        const titleEl = card.querySelector('.product-card__title');
        if (titleEl) title = titleEl.textContent.trim();

        let price = 0;
        let compareAtPrice = 0;
        const priceAttr = card.dataset.price || card.getAttribute('data-price');
        if (priceAttr) {
          price = parseInt(priceAttr, 10);
        }

        const compareAtPriceAttr = card.dataset.compareAtPrice || card.getAttribute('data-compare-at-price');
        if (compareAtPriceAttr) {
          compareAtPrice = parseInt(compareAtPriceAttr, 10);
        }

        let promoText = '';
        let promoPrice = price;
        const promoEl = card.querySelector('[data-js="product-card-promo"]');
        if (promoEl) promoText = promoEl.textContent.trim();
        if (card.__productData && card.__productData.promo_price) {
          promoPrice = parseInt(card.__productData.promo_price, 10) || price;
          promoText = promoText || card.__productData.promo_message || '';
        } else if (promoText) {
          const promoPriceAttr = card.dataset.promoPrice || card.getAttribute('data-promo-price');
          promoPrice = parseInt(promoPriceAttr, 10) || price;
        }

        let image = '';
        const originalFirstSlide = card.querySelector('[data-fresh-original-index="0"]');
        const imgEl = originalFirstSlide ? originalFirstSlide.querySelector('img') : card.querySelector('img');
        if (imgEl) image = imgEl.getAttribute('data-src') || imgEl.src;

        let variants = [];
        const dataScript = card.querySelector('[data-js="quick-add-data"]');
        if (dataScript) {
          try {
            const data = JSON.parse(dataScript.textContent);
            variants = data.variants || [];
          } catch (e) {}
        } else if (card.__productData && card.__productData.variants) {
          variants = card.__productData.variants;
        }

        currentAddProduct = {
          id: productId,
          handle: productHandle,
          url: window.location.origin + '/products/' + productHandle,
          title: title,
          price: price,
          compareAtPrice: compareAtPrice,
          promoPrice: promoPrice,
          promoText: promoText,
          image: image,
          variants: variants
        };

        addToListMode = true;
        selectedAddVariantId = null;
        selectedAddListIds = [];
        openDrawer();
      }

      const trigger = e.target.closest('[data-swym-wishlist-trigger]');
      if (trigger) {
        e.preventDefault();
        openDrawer();
      }

      const quickAddTrigger = e.target.closest('[data-js="quick-add-wishlist"]');
      if (quickAddTrigger && quickAddTrigger.__productData) {
        e.preventDefault();
        e.stopPropagation();
        
        const data = quickAddTrigger.__productData;
        currentAddProduct = {
          id: data.id,
          handle: data.handle,
          url: window.location.origin + '/products/' + data.handle,
          title: data.title,
          price: data.price,
          compareAtPrice: data.compareAtPrice,
          promoPrice: data.promoPrice || 0,
          promoText: data.promoText || '',
          image: data.image,
          variants: data.variants
        };

        addToListMode = true;
        selectedAddVariantId = null;
        selectedAddListIds = [];

        // Slide out the quick add drawer
        const quickAddClose = document.querySelector('[data-js="quick-add-close"]');
        if (quickAddClose) {
          quickAddClose.click();
        }

        openDrawer();
      }

      const pdpWishlistTrigger = e.target.closest('[data-js="product-wishlist"]');
      if (pdpWishlistTrigger) {
        e.preventDefault();
        e.stopPropagation();
        
        const dataScript = pdpWishlistTrigger.nextElementSibling;
        if (dataScript && dataScript.matches('[data-js="product-wishlist-data"]')) {
          try {
            const data = JSON.parse(dataScript.textContent);
            currentAddProduct = {
              id: data.id,
              handle: data.handle,
              url: window.location.origin + '/products/' + data.handle,
              title: data.title,
              price: data.price,
              compareAtPrice: data.compareAtPrice,
              promoPrice: data.promoPrice || 0,
              promoPercent: data.promoPercent || 0,
              image: data.image,
              variants: data.variants || []
            };

            addToListMode = true;
            selectedAddVariantId = null;
            selectedAddListIds = [];

            openDrawer();
          } catch (err) {
            console.error('Failed to parse PDP wishlist data', err);
          }
        }
      }

    }, true); // Use capture phase for the global click listener like quick-add
  })();
